module.exports = __webpack_public_path__ + "img/insert-2.f4135487.png";